var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBagsShopping = function SvgBagsShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#867659",
    d: "M13.2 12c0-3.315 2.685-6 6-6s6 2.685 6 6v4.8h-12zM12 16.8H2.4v24h12v-1.2H3.6V18h31.2v3.6H36v-4.8h-9.6V12c0-3.975-3.225-7.2-7.2-7.2A7.2 7.2 0 0 0 12 12zm6 8.4h26.4V42H18zM16.8 24v19.2h28.8V24H16.8m9.6 5.4v-.6h-1.2v3.6c0 3.315 2.685 6 6 6s6-2.685 6-6v-3.6H36v3.6c0 2.647-2.152 4.8-4.8 4.8a4.804 4.804 0 0 1-4.8-4.8z"
  })));
};
export default SvgBagsShopping;